import { AfterContentInit, ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { SetHasPipe } from '../../pipes/set-has.pipe';

@Component({
  selector: 'app-stepper',
  standalone: true,
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  imports: [CommonModule, SetHasPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStepper, useExisting: forwardRef(() => StepperComponent) }]
})
export class StepperComponent extends CdkStepper implements AfterContentInit {
  @Input() public showSteps = true;
  @Input() public forcedCompletedSteps: Set<number> = new Set<number>();
  @Input() public forcedErrorSteps: Set<number> = new Set<number>();
}
